import OverflowTooltip from 'components/pure/utils/OverflowTooltip';
import React from 'react';

/**
 * A single row in a legend, used by Simple and Grouping legends
 */
export class LegendRow extends React.PureComponent {
  constructor(props) {
    super(props);

    this.togglePinned = this.togglePinned.bind(this);
    this.shouldRenderActive = this.shouldRenderActive.bind(this);
    this.legendMouseLeave = this.legendMouseLeave.bind(this);

    this.state = {
      isPinned: false,
      wasJustUnpinned: false,
    };
  }

  togglePinned() {
    const {togglePin, index} = this.props;
    const {isPinned} = this.state;

    togglePin(index);

    if (!isPinned) {
      this.setState({isPinned: true});
    } else {
      this.setState({isPinned: false, wasJustUnpinned: true});
    }
  }

  /**
   * Render the row "active" (colored background) if the trend is pinned
   * or the user is hovering over it. Although - if the user had pinned
   * then unpinned, they're still hovering that row, in which case we use
   * a special flag "wasJustUnpinned" to catch that
   *
   * (we reset this after mouseout)
   *
   * @return {boolean}
   */
  shouldRenderActive() {
    const {hoverIndex, index} = this.props;
    const {isPinned, wasJustUnpinned} = this.state;

    const isCurrentlyHovered = hoverIndex === index;

    return (isCurrentlyHovered && !wasJustUnpinned) || isPinned;
  }

  legendMouseLeave() {
    this.props.legendMouseLeave();
    this.setState({wasJustUnpinned: false});
  }

  render() {
    const {item, index, legendMouseEnter} = this.props;

    const shouldRenderActive = this.shouldRenderActive();

    return (
      <li
        key={`legend-${item.label}-${index}`}
        className={shouldRenderActive ? 'active' : ''}
        onClick={this.togglePinned}
        onMouseEnter={() => legendMouseEnter(index)}
        onMouseLeave={this.legendMouseLeave}>
        <div className="legend-icon" style={{backgroundColor: item.color}} />
        <OverflowTooltip divKey={`label-${item.label}-${index}`} tooltipText={item.label}>
          <span className="legend-label">{item.label}</span>
        </OverflowTooltip>
      </li>
    );
  }
}

export default LegendRow;
